/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */

import React from 'react';
import Figure from '../Figure';
import FigCaption from '../FigCaption';
import FigContainer from '../FigContainer';
import CategoryHeader from '../CategoryHeader';

/* eslint-disable prettier/prettier */
import IconBusiness from '../../../../../../Icon/IconBusiness';
import IconCall from '../../../../../../Icon/IconCall';
import IconCallEnd from '../../../../../../Icon/IconCallEnd';
import IconCallMade from '../../../../../../Icon/IconCallMade';
import IconCallMerge from '../../../../../../Icon/IconCallMerge';
import IconCallMissed from '../../../../../../Icon/IconCallMissed';
import IconCallMissedOutgoing from '../../../../../../Icon/IconCallMissedOutgoing';
import IconCallReceived from '../../../../../../Icon/IconCallReceived';
import IconCallSplit from '../../../../../../Icon/IconCallSplit';
import IconChat from '../../../../../../Icon/IconChat';
import IconChatBubble from '../../../../../../Icon/IconChatBubble';
import IconChatBubbleOutline from '../../../../../../Icon/IconChatBubbleOutline';
import IconClearAll from '../../../../../../Icon/IconClearAll';
import IconComment from '../../../../../../Icon/IconComment';
import IconContactMail from '../../../../../../Icon/IconContactMail';
import IconContactPhone from '../../../../../../Icon/IconContactPhone';
import IconContacts from '../../../../../../Icon/IconContacts';
import IconDialerSip from '../../../../../../Icon/IconDialerSip';
import IconDialpad from '../../../../../../Icon/IconDialpad';
import IconEmail from '../../../../../../Icon/IconEmail';
import IconForum from '../../../../../../Icon/IconForum';
import IconImportContacts from '../../../../../../Icon/IconImportContacts';
import IconImportExport from '../../../../../../Icon/IconImportExport';
import IconInvertColorsOff from '../../../../../../Icon/IconInvertColorsOff';
import IconLiveHelp from '../../../../../../Icon/IconLiveHelp';
import IconLocationOff from '../../../../../../Icon/IconLocationOff';
import IconLocationOn from '../../../../../../Icon/IconLocationOn';
import IconMailOutline from '../../../../../../Icon/IconMailOutline';
import IconMessage from '../../../../../../Icon/IconMessage';
import IconNoSim from '../../../../../../Icon/IconNoSim';
import IconPhone from '../../../../../../Icon/IconPhone';
import IconPhonelinkErase from '../../../../../../Icon/IconPhonelinkErase';
import IconPhonelinkLock from '../../../../../../Icon/IconPhonelinkLock';
import IconPhonelinkRing from '../../../../../../Icon/IconPhonelinkRing';
import IconPhonelinkSetup from '../../../../../../Icon/IconPhonelinkSetup';
import IconPortableWifiOff from '../../../../../../Icon/IconPortableWifiOff';
import IconPresentToAll from '../../../../../../Icon/IconPresentToAll';
import IconRingVolume from '../../../../../../Icon/IconRingVolume';
import IconRssFeed from '../../../../../../Icon/IconRssFeed';
import IconScreenShare from '../../../../../../Icon/IconScreenShare';
import IconSpeakerPhone from '../../../../../../Icon/IconSpeakerPhone';
import IconStayCurrentLandscape from '../../../../../../Icon/IconStayCurrentLandscape';
import IconStayCurrentPortrait from '../../../../../../Icon/IconStayCurrentPortrait';
import IconStayPrimaryLandscape from '../../../../../../Icon/IconStayPrimaryLandscape';
import IconStayPrimaryPortrait from '../../../../../../Icon/IconStayPrimaryPortrait';
import IconStopScreenShare from '../../../../../../Icon/IconStopScreenShare';
import IconSwapCalls from '../../../../../../Icon/IconSwapCalls';
import IconTextsms from '../../../../../../Icon/IconTextsms';
import IconVoicemail from '../../../../../../Icon/IconVoicemail';
import IconVpnKey from '../../../../../../Icon/IconVpnKey';

export default function CommunicationIcons() {
  return (
    <div>
      <CategoryHeader>communication</CategoryHeader>
      <FigContainer>
        <Figure tabIndex={0}>
          <IconBusiness size="32"/>
          <FigCaption>
            IconBusiness
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCall size="32"/>
          <FigCaption>
            IconCall
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCallEnd size="32"/>
          <FigCaption>
            IconCallEnd
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCallMade size="32"/>
          <FigCaption>
            IconCallMade
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCallMerge size="32"/>
          <FigCaption>
            IconCallMerge
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCallMissed size="32"/>
          <FigCaption>
            IconCallMissed
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCallMissedOutgoing size="32"/>
          <FigCaption>
            IconCallMissedOutgoing
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCallReceived size="32"/>
          <FigCaption>
            IconCallReceived
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCallSplit size="32"/>
          <FigCaption>
            IconCallSplit
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconChat size="32"/>
          <FigCaption>
            IconChat
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconChatBubble size="32"/>
          <FigCaption>
            IconChatBubble
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconChatBubbleOutline size="32"/>
          <FigCaption>
            IconChatBubbleOutline
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconClearAll size="32"/>
          <FigCaption>
            IconClearAll
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconComment size="32"/>
          <FigCaption>
            IconComment
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconContactMail size="32"/>
          <FigCaption>
            IconContactMail
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconContactPhone size="32"/>
          <FigCaption>
            IconContactPhone
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconContacts size="32"/>
          <FigCaption>
            IconContacts
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDialerSip size="32"/>
          <FigCaption>
            IconDialerSip
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDialpad size="32"/>
          <FigCaption>
            IconDialpad
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconEmail size="32"/>
          <FigCaption>
            IconEmail
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconForum size="32"/>
          <FigCaption>
            IconForum
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconImportContacts size="32"/>
          <FigCaption>
            IconImportContacts
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconImportExport size="32"/>
          <FigCaption>
            IconImportExport
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconInvertColorsOff size="32"/>
          <FigCaption>
            IconInvertColorsOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLiveHelp size="32"/>
          <FigCaption>
            IconLiveHelp
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocationOff size="32"/>
          <FigCaption>
            IconLocationOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLocationOn size="32"/>
          <FigCaption>
            IconLocationOn
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMailOutline size="32"/>
          <FigCaption>
            IconMailOutline
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMessage size="32"/>
          <FigCaption>
            IconMessage
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconNoSim size="32"/>
          <FigCaption>
            IconNoSim
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhone size="32"/>
          <FigCaption>
            IconPhone
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhonelinkErase size="32"/>
          <FigCaption>
            IconPhonelinkErase
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhonelinkLock size="32"/>
          <FigCaption>
            IconPhonelinkLock
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhonelinkRing size="32"/>
          <FigCaption>
            IconPhonelinkRing
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPhonelinkSetup size="32"/>
          <FigCaption>
            IconPhonelinkSetup
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPortableWifiOff size="32"/>
          <FigCaption>
            IconPortableWifiOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPresentToAll size="32"/>
          <FigCaption>
            IconPresentToAll
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRingVolume size="32"/>
          <FigCaption>
            IconRingVolume
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRssFeed size="32"/>
          <FigCaption>
            IconRssFeed
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconScreenShare size="32"/>
          <FigCaption>
            IconScreenShare
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSpeakerPhone size="32"/>
          <FigCaption>
            IconSpeakerPhone
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconStayCurrentLandscape size="32"/>
          <FigCaption>
            IconStayCurrentLandscape
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconStayCurrentPortrait size="32"/>
          <FigCaption>
            IconStayCurrentPortrait
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconStayPrimaryLandscape size="32"/>
          <FigCaption>
            IconStayPrimaryLandscape
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconStayPrimaryPortrait size="32"/>
          <FigCaption>
            IconStayPrimaryPortrait
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconStopScreenShare size="32"/>
          <FigCaption>
            IconStopScreenShare
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSwapCalls size="32"/>
          <FigCaption>
            IconSwapCalls
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTextsms size="32"/>
          <FigCaption>
            IconTextsms
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconVoicemail size="32"/>
          <FigCaption>
            IconVoicemail
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconVpnKey size="32"/>
          <FigCaption>
            IconVpnKey
          </FigCaption>
        </Figure>
      </FigContainer>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/website/app/demos/Icon/components/categories/CommunicationIcons.js